module.exports = __webpack_public_path__ + "static/media/2.869cec91.svg";